import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { PlusIcon, UserIcon } from 'lucide-react';
export function NotesTab({
  contact
}) {
  const [newNote, setNewNote] = useState('');
  const formatDate = dateString => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    }).format(date);
  };
  const handleAddNote = e => {
    e.preventDefault();
    // This would typically add the note to the contact's notes array
    // and potentially make an API call
    setNewNote('');
  };
  return <div data-id="element-375">
      <Card title="Add Note" data-id="element-376">
        <form onSubmit={handleAddNote} data-id="element-377">
          <textarea value={newNote} onChange={e => setNewNote(e.target.value)} placeholder="Add a note about this contact..." className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 min-h-[100px]" data-id="element-378"></textarea>
          <div className="mt-3 flex justify-end" data-id="element-379">
            <button type="submit" className="flex items-center gap-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" disabled={!newNote.trim()} data-id="element-380">
              <PlusIcon className="w-4 h-4" data-id="element-381" />
              <span data-id="element-382">Add Note</span>
            </button>
          </div>
        </form>
      </Card>
      <h3 className="font-medium text-gray-700 mt-6 mb-3" data-id="element-383">Notes History</h3>
      <div className="space-y-4" data-id="element-384">
        {contact.notes.map(note => <div key={note.id} className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-385">
            <div className="flex items-start gap-3" data-id="element-386">
              <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0" data-id="element-387">
                <UserIcon className="w-4 h-4 text-gray-600" data-id="element-388" />
              </div>
              <div className="flex-grow" data-id="element-389">
                <div className="flex justify-between items-center mb-2" data-id="element-390">
                  <h4 className="font-medium text-gray-800" data-id="element-391">{note.author}</h4>
                  <span className="text-xs text-gray-500" data-id="element-392">
                    {formatDate(note.date)}
                  </span>
                </div>
                <p className="text-gray-700 whitespace-pre-line" data-id="element-393">
                  {note.content}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}